<script lang="ts" setup>
  import type { PlayersGuessingView } from '../../../../shared/api/round.ts';
  import { MobileViewLayout } from '../../../../shared/ui/mobile-view-layout';
  import SongCard from '../song/SongCard.vue';
  import RoundHeader from './RoundHeader.vue';
  import RoundsUntilIChoose from './RoundsUntilIChoose.vue';

  defineProps<{ data: PlayersGuessingView; secondsLeft: string; isHost: boolean }>();
</script>

<template>
  <MobileViewLayout space="m">
    <template #header>
      <RoundHeader :is-host="isHost" :seconds-left="secondsLeft" :view="data" />
    </template>

    <RoundsUntilIChoose :rounds-until-i-choose="data.roundsUntilIChoose" />

    <div class="chooser-info">
      <span class="chooser-label">waiting for other players to guess the song</span>
      <template v-if="data.round.chooser">
        <span class="chooser-name">{{ data.round.chooser.nickname }}</span>
        <span class="chooser-label">chose!</span>
      </template>
    </div>

    <SongCard v-if="data.round.songSubmission" :song="data.round.songSubmission.song" label="you guessed" />
  </MobileViewLayout>
</template>

<style scoped>
  .chooser-info {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .chooser-label {
    color: var(--color-text-muted);
    font-size: var(--font-size-xs);
    letter-spacing: 0.1em;
    text-align: center;
    text-transform: uppercase;
  }

  .chooser-name {
    color: var(--color-primary);
    font-family: var(--font-nickname);
    font-size: var(--font-size-lg);
    line-height: 1.1;
    text-align: center;
    text-transform: uppercase;
  }
</style>
